'use strict';
const angular = require('angular');

export class NewsPostComponent {
  /*@ngInject*/
  constructor() {
    this.$onChanges = function (changesObj) {
      if (changesObj.data && this.data && this.data.attachments) {
        var that = this;

        this.galleryImages = this.data.attachments.filter(attachment => {
          return that.isImageMime(attachment.contentType);
        });

        this.galleryImages = this.galleryImages.map(function(obj){
          var rObj = {};

          rObj.title = obj.filename;
          rObj.alt = obj.filename;
          rObj.url = "/api/storage/" + obj._id;
          rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

          return rObj;
        });
      }
    };
  }

  getPreviewText(text) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ').substr(0, 300) + '...' : '';
  }

  getUserShort(user) {
    return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }
}

export default angular.module('conduuApp.newsPost', [])
  .component('newsPost', {
    template: require('./NewsPost.html'),
    bindings: {
      preview: '<',
      detail: '<',
      feature: '<',
      data: '<',
      admin: '<',
      delete: '&',
      type: '<'
    },
    controller: NewsPostComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/news/post/NewsPost.component.js